module.exports = __webpack_public_path__ + "img/card-medicalplan-hover.89f29c45.svg";